/**
 * @description 浏览器相关方案集合
 * @author shuowang13
 * @time 20231109
 */
// 是否是可触屏设备（手机、pad、电视）
export const isIpad = () => {
  if (navigator.userAgent.match(/iPad|iPhone/i)) {
    return true
  } else {
    return false
  }
}
// 是否是移动端设备
export const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent)
// 移动端/平板 UA 判断（比 isMobile 更宽，包含 iPad 等设备）
export const MOBILE_UA_REGEX =
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
// 同步判断是否移动端：只读 UA，不依赖 DOM，可在 data() 中直接求值。
// 组件必须在首次渲染前拿到正确值，否则移动端会先渲染 PC 版再切换，造成布局跳变（CLS）
export const isMobileUA = () => MOBILE_UA_REGEX.test(window.navigator.userAgent)
// 是否是chrome浏览器包含移动端chrome
export const isChrome = () => {
  const userAgent = navigator.userAgent
  if (
    (userAgent.indexOf('Chrome') !== -1 &&
      userAgent.indexOf('Safari') !== -1 &&
      userAgent.indexOf('Edg') === -1) ||
    userAgent.indexOf('CriOS') !== -1
  ) {
    return true // Chrome包含移动端chrome
  } else if (userAgent.indexOf('Firefox') !== -1) {
    return false // Firefox
  } else if (
    userAgent.indexOf('Safari') !== -1 &&
    userAgent.indexOf('Chrome') === -1 &&
    userAgent.indexOf('Edge') === -1
  ) {
    return false // Safari
  } else if (userAgent.indexOf('Edg') !== -1) {
    return false // Edge
  } else {
    return false // 其他浏览器...
  }
}
// 是否展示"建议使用 Chrome"提示条。
// sessionStorage 与 UA 均可同步读取，必须在首帧就确定：
// 若等到 mounted 后再插入提示条，会把整页向下推，造成布局跳变（CLS）
export const shouldShowBrowserPrompt = () =>
  !sessionStorage.getItem('hideBrowserLayer') && !isChrome()
